import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

export enum CustomWallpaperUpsellCalloutsVariation {
  on = 'engaged',
  off = 'disengaged',
}

export default class CustomWallpaperUpsellCallouts {
  static key = 'custom-wallpaper-upsell-callouts';

  static isOn(): boolean {
    return this.currentVariant() === CustomWallpaperUpsellCalloutsVariation.on;
  }

  static isOff(): boolean {
    return this.currentVariant() === CustomWallpaperUpsellCalloutsVariation.off;
  }

  static currentVariant(): string | undefined {
    return getFullVariant(this.key, {
      value: CustomWallpaperUpsellCalloutsVariation.off,
    }).value;
  }
}
